import { Button, ButtonProps } from './ui/button';
import { cn } from '../lib/utils';
import { transCls } from '../const/ui';

export interface PrimaryConfirmBtnProps extends ButtonProps {
  text?: string;
  prefixDesc?: string;
  icon?: React.ReactNode;
  disabledWithInfo?: boolean;
  light?: boolean;
}

export const PrimaryConfirmBtn = ({
  text = '确认',
  prefixDesc,
  className,
  disabled,
  light,
  icon,
  children,
  ...rest
}: PrimaryConfirmBtnProps) => {
  const btn = (
    <Button
      {...rest}
      variant="default"
      disabled={disabled}
      className={cn(
        'px-[10px] py-0 rounded-[100px] text-[14px] leading-normal h-[34px] min-w-[100px] cursor-pointer w-full disabled:opacity-100 gap-[6px] shadow-none',
        disabled
          ? 'bg-[#f0f0f0] text-[#999] cursor-not-allowed shadow-none'
          : light
            ? 'bg-[#F0F6FF] text-[#0265FF] hover:bg-[#0265FF] hover:text-white'
            : 'bg-[#0265ff] text-white hover:bg-[#0265ff]/80',

        transCls,
        {
          '!bg-[#E5E6EB] !text-[#121111] shadow-none font-[400]': rest.disabledWithInfo,
        },
        className
      )}
    >
      {icon}
      {children || text}
    </Button>
  );

  if (!prefixDesc) {
    return btn;
  }

  return (
    <div className="flex flex-col items-start gap-2.5">
      <p className="text-[#4D609F]">{prefixDesc}</p>
      {btn}
    </div>
  );
};
